import * as React from 'react';
import { createElement } from 'react';
import { Form } from '@alifd/next';
const { Item } = Form;
const FormItem = (props, ref) => {
    const { children = [], ...otherProps } = props;
    return createElement(Item, { ...otherProps }, React.Children.map(children, (child) => {
        if (!child) {
            return null;
        }
        const { props: _props = {} } = child;
        const { defaultValue, value, ...restProps } = _props;
        const { __designMode } = restProps;
        const finalValue = __designMode === 'design' ? defaultValue : value;
        if (finalValue) {
            restProps.value = finalValue;
        }
        return React.cloneElement(child, { ..._props, ...restProps });
    }));
};
const FormItemRef = React.forwardRef(FormItem);
FormItemRef.displayName = 'FormItem';
export default FormItemRef;
